import { User2Icon, X } from "lucide-react";
import React from "react";
import useAdminProfile from "../../store/admin/profile";

function ViewAdminProfile() {
  const { profileData, setIsProfileClicked } = useAdminProfile();

  if (!profileData) return null;

  return (
    <div className="fixed overflow-hidden inset-0 z-50 flex items-center justify-center">
      
      {/* Overlay */}
      <div
        onClick={() => setIsProfileClicked(false)}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
      />

      {/* Modal */}
      <div className="relative max-h-[calc(100%-80px)] overflow-y-auto bg-white w-[95%] max-w-3xl rounded-2xl shadow-2xl p-8">

        {/* Header */}
        <div className="relative flex items-center justify-between bg-gradient-to-r from-blue-200 to-white p-2 sm:p-6 rounded-2xl shadow-sm border border-gray-100 mb-6">
          
          <div className="flex items-center gap-5">

            {/* Avatar */}
            <div className="relative sm:w-24 sm:h-24 w-16 h-16 rounded-2xl overflow-hidden shadow-md border border-gray-200 bg-white flex items-center justify-center">
              {profileData?.imageUrl ? (
                <img
                  src={profileData.imageUrl}
                  alt="Admin"
                  className="w-full h-full object-cover"
                />
              ) : (
                <User2Icon
                  className="w-10 h-10 text-blue-500"
                  strokeWidth={1.8}
                />
              )}
            </div>

            {/* Title Section */}
            <div className="flex flex-col">
              <span className="text-xs uppercase tracking-widest text-gray-400 font-medium">
                Admin Profile
              </span>

              <h2 className="text-3xl font-bold text-gray-800 leading-tight">
                {profileData?.title} {profileData?.name}
              </h2>

              <p className="text-sm text-gray-500">
                {profileData?.email}
              </p>
            </div>
          </div>

          {/* Close Button */}
          <button
            onClick={() => setIsProfileClicked(false)}
            className="absolute top-4 -right-4 sm:right-4 bg-white border border-gray-200 rounded-full p-2 text-gray-400 hover:text-red-500 hover:shadow-md transition-all duration-200"
          >
            <X className="w-5 h-5" strokeWidth={2} />
          </button>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">

          <div>
            <p className="text-gray-500">Admin ID</p>
            <p className="font-medium text-gray-800">
              {profileData?.id}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Mobile</p>
            <p className="font-medium text-gray-800">
              {profileData?.mobile}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Gender</p>
            <p className="font-medium text-gray-800 capitalize">
              {profileData?.gender}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Date of Birth</p>
            <p className="font-medium text-gray-800">
              {profileData?.dob
                ? new Date(profileData.dob).toLocaleDateString()
                : "—"}
            </p>
          </div>

          <div className="sm:col-span-2">
            <p className="text-gray-500">Address</p>
            <p className="font-medium text-gray-800">
              {profileData?.address}
            </p>
          </div>

          {/* Status */}
          <div>
            <p className="text-gray-500">Status</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                profileData?.isActive === 1
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {profileData?.isActive === 1 ? "Active" : "Inactive"}
            </span>
          </div>

          {/* Deleted */}
          <div>
            <p className="text-gray-500">Deleted</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                profileData?.isDeleted === 1
                  ? "bg-red-100 text-red-600"
                  : "bg-blue-100 text-blue-700"
              }`}
            >
              {profileData?.isDeleted === 1 ? "Yes" : "No"}
            </span>
          </div>

          {/* Optional Dates */}
          {profileData?.deactivatedAt && (
            <div>
              <p className="text-gray-500">Deactivated At</p>
              <p className="font-medium text-gray-800">
                {new Date(profileData.deactivatedAt).toLocaleString()}
              </p>
            </div>
          )}

          {profileData?.deletedAt && (
            <div>
              <p className="text-gray-500">Deleted At</p>
              <p className="font-medium text-gray-800">
                {new Date(profileData.deletedAt).toLocaleString()}
              </p>
            </div>
          )}

          <div>
            <p className="text-gray-500">Created At</p>
            <p className="font-medium text-gray-800">
              {new Date(profileData?.created_at).toLocaleString()}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Updated At</p>
            <p className="font-medium text-gray-800">
              {new Date(profileData?.updated_at).toLocaleString()}
            </p>
          </div>

        </div>

        {/* Footer */}
        <div className="mt-8 text-right">
          <button
            onClick={() => setIsProfileClicked(false)}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewAdminProfile;